export default {
  "b2b.zakaznik-detail.notfound": "Zákazník IČO: {ico} nebyl nalezen."
};
